"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.rgb2hex=function(e,t,r){var o=((1<<24)+(e<<16)+(t<<8)+r).toString(16).slice(1);return"#".concat(o)};
